import slick from  '../vendors/slider.min';

class BjzmSlideshow  {
	
	constructor() {
		this.sliders = {};
		this.pagers = {};
		this.homeSliderDelay = 2000;
		this.setSelects();
		this.setSettings();
		this.initSliders();
		this.sliderEvents();
	}

	setSettings() {
		this.typeSettings = {
			'dropdown-toggles': {
				'fade': true,
				'speed': 700,
				dots: false,
				autoplay: false
			},
			'master-plan': {
				'fade': true,
				'speed': 700,
				dots: false,
				autoplay: false
			},
			'home': {
				'fade': true,
				'speed': 300,
				dots: false,
				autoplay: false
			},
			'inline': {
				fade: true,
				'speed': 300,
				'dots': true,
				autoplay: true
			},
			'full-width': {
				'fade': true,
				'speed': 300,
				dots: false,
				autoplay: false
			},
			'card-slider': {
				'fade': true,
				'speed': 300,
				dots: false,
				autoplay: false
			}
		}
	}
	
	setSelects() {
		function iformat(icon) {
			var originalOption = icon.element;
			return $('<span class="slideshow-select-item">' + icon.text + '</span>');
		}

		$(".slider-side__nav-select").select2({
			tags: false,
			templateResult: iformat,
			minimumResultsForSearch: -1
		});
		$(".select2-container").append('<div class="select2-arrows"><img class="select2-arrows__normal" src="https://dev.blackjetinteractive.com/2018/zibi/wp-content/themes/zibi-theme/assets/img/dropdown-toggles-dark.png"><img class="select2-arrows__hover" src="https://dev.blackjetinteractive.com/2018/zibi/wp-content/themes/zibi-theme/assets/img/dropdown-toggles-light.png"></div>');

		$(".slider-side__side-select").select2({
			tags: false,
			templateResult: iformat,
			minimumResultsForSearch: -1
		});

		$(".select2-arrows").on('click', function(){
			//console.log('click');
			$(this).closest('.select2').siblings(".slider-select").select2('open');
		})


	}

	initSliders() {
		/*console.log('test');*/

		if( $(".bjzm-slideshow__list").length > 0 ) {

			/*console.log('slider-test');*/
			
			$('.bjzm-slideshow__list').each( (index, el) => {
				
				var sliderId = $(el).attr('id');
				var sliderType = $(el).data('slider-type');
				var autoplay = 'home' == sliderType ? true : false;

				//console.log('sliderType', sliderType);

				var sync = $(el).data('sync');
				this.duration = 4500;

				this.sliders[sliderId] = {}
				this.sliders[sliderId].slider = $(el);
				this.sliders[sliderId].sliderFooter = $(`.bjzm-slideshow__footer--${sliderId}`);

				var centerMode =  $(el).data('slider-type') == 'carousel' ? true : false;

				this.sliders[sliderId].slider.on('init', (event, slick) => {
					this.onInit(event, slick, sliderId);
				});

				this.sliders[sliderId].slider.on('afterChange', (event, slick, currentSlide) => {
					this.onAfterChange(event, slick, currentSlide, sliderId, sliderType);
				} );
				this.sliders[sliderId].slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
					this.onBeforeChange(event, slick, currentSlide, nextSlide, sliderId, sliderType);
				} );

				this.sliders[sliderId].slider.slick({ 
					centerMode: false,
					dots: this.typeSettings[sliderType].dots,
					centerPadding: 0,
					slidesToShow: 1,
					variableWidth: false,
					arrows: false,
					infinite: true,
					adaptiveHeight: false,
					fade: this.typeSettings[sliderType].fade,
					autoplay: this.typeSettings[sliderType].autoplay,
					autoplaySpeed: this.duration,
					pauseOnHover: false,
					useCSS: true,
					cssEase: 'linear',
					speed: this.typeSettings[sliderType].speed,
				});

				if( 'home' == sliderType ) {
					this.sliders[sliderId].slider.slick('slickPause');
					setTimeout(()=>{
						this.sliders[sliderId].slider.slick('slickPlay');
					}, this.homeSliderDelay);
				}

			});

		}

	}

	onInit(event, slick, sliderId) {
		$(`#${sliderId}`).find('.slick-arrow').addClass(sliderId);
		this.sliders[sliderId].sliderFooter.find('.slide-pager__number--total').html(slick.slideCount);
		this.sliders[sliderId].currentSlideIndex = 0;
		
		if( $(`.slide-counter--${sliderId}`).length > 0 ) {
			$(`.slide-counter--${sliderId}`).find(".slide-counter__value--total").html(slick.slideCount);
		}	

		/*master on init*/
		if( $('.plan-content-outer').length > 0 ) {
			setTimeout(() => {

				var $activeSlide = $('.plan-content-outer').find(`.plan-content`).first();
				var activeSlideHeight = $activeSlide.outerHeight();

				//$activeSlide.closest('.bjzm-slideshow__sidebar').animate({height: activeSlideHeight} );

				$activeSlide.addClass('plan-content--fade-in');

				$activeSlide.closest('.bjzm-slideshow__sidebar').animate({height: activeSlideHeight} );




				this.resetHomeProgress();
			}, this.homeSliderDelay);
		}
		
	}

	resetHomeProgress() {
		$(".slider-progress__bar").css('transition', `none`);
		$(".slider-progress").removeClass('slider-progress--full');
		setTimeout(()=> {
			$(".slider-progress__bar").css('transition', `all ${this.duration}ms linear`);
			$(".slider-progress").addClass('slider-progress--full');
		},100)
	}

	onBeforeChange(event, slick, currentSlide, nextSlide, sliderId, sliderType) {
		if( $(`.slide-counter--${sliderId}`).length > 0 ) {
			var slideIndex = nextSlide + 1;
			var i = (nextSlide ? nextSlide : 0) + 1;
			$(`.slide-counter--${sliderId}`).addClass('go-out');
			setTimeout(function(){
				$(`.slide-counter--${sliderId}`).removeClass('go-out');
				$(`.slide-counter--${sliderId}`).addClass('go-in');
				$(`.slide-counter--${sliderId}`).find('.slide-counter__value--current').html(i);
			}, 300);
			setTimeout(function(){
				$(`.slide-counter--${sliderId}`).removeClass('go-in');
				$(`.slide-counter--${sliderId}`).removeClass('go-out');
				$(`.slide-counter--${sliderId}`).find('.slide-counter__value--current').html(i);
			}, 700);

		}
		if( 'master-plan' == sliderType ) {
			$('.plan-content').addClass('plan-content--fade-out');
		}

		if( $(`.card-slider-content--${sliderId}`).length > 0 ) {
			var slideIndex = nextSlide;
			setTimeout(function(){
				$(`.card-slider-content--${sliderId}`)
				.find(`.card-slider-content__item--count-${slideIndex}`)
				.addClass('card-slider-content__item--active')
				.siblings().removeClass('card-slider-content__item--active');
			}, 400);

		}

		if( $(`.slider-side--${sliderId}` ).length > 0 ) {
			var slideIndex= nextSlide;
			var sliderSelector = `.slider-side--${sliderId}`;
			var navItemSelector = `.slider-side__item--count-${slideIndex}`;
			$( sliderSelector ).find(navItemSelector)
			.addClass('slider-side__item--active')
			.siblings().removeClass('slider-side__item--active');
		}


	}

	onAfterChange(event, slick, currentSlide, sliderId, sliderType) {
		
		this.sliders[sliderId].currentSlideCount = currentSlide + 1;
		this.sliders[sliderId].currentSlideIndex = currentSlide;

		this.sliders[sliderId].sliderFooter.find('.slide-pager__number--index').html(this.sliders[sliderId].currentSlideCount);

		/*setting the height*/

		/*master content fade in*/
		if( 'master-plan' == sliderType ) {
			var slideindex = currentSlide + 1;
			var $activeSlide = $('.plan-content-outer').find(`.plan-content--${slideindex}`)
			var activeSlideHeight = $activeSlide.outerHeight();

			$activeSlide.closest('.bjzm-slideshow__sidebar').animate({height: activeSlideHeight} );

			$('.plan-content-outer')
			.find(`.plan-content--${slideindex}`)
			.addClass('plan-content--fade-in')
			.siblings().removeClass('plan-content--fade-in');
			setTimeout(function(){
				$('.plan-content').removeClass('plan-content--fade-out');
			}, 400);

		}

	}

	sliderEvents() {
		var self = this;

		function handlenNavLinkClick( sliderId, direction ) {
			self.handleNextPrevAction( sliderId, direction );
		}

		$(".bjzm-slideshow__nav-link").on('click', (e) => {
			e.preventDefault();
			
			var sliderId = $(e.currentTarget).data('slider-id');
			var direction = $(e.currentTarget).data('direction');
			//console.log( sliderId, direction );
			handlenNavLinkClick( sliderId, direction );

		});


				/*$(".slider-side__side-select")*/

		


		function handlenSideLinkClick(sliderId, slideKey) {
			self.sliders[sliderId].slider.slick('slickGoTo', slideKey);
		}

		if( $(".slider-side__link").length > 0 ) {

			$(".slider-side__link").on('click', (e) => {
				e.preventDefault();

				//console.log('put the select in here as well');
				
				var $this = $(e.currentTarget);
				var sliderId = $this.data('slider-id');
				var slideKey = $this.data('slide-key');
				handlenSideLinkClick(sliderId, slideKey);

			});
			$(".slider-side__nav-select").on('change', (e) => {
				var sliderId = $(e.currentTarget).attr('data-slider-id');
				var slideKey = $(e.currentTarget).val();
				var id = $(e.currentTarget).attr('id');
				//console.log(sliderId, id, slideKey);
				handlenSideLinkClick(sliderId, slideKey);

			});
		}

	}

	handleNextPrevAction( sliderId, direction ) {

		var nextPrev = direction > 0 ? 'slickNext' : 'slickPrev';

		this.sliders[sliderId].slider.slick(nextPrev);

	}

}

module.exports = BjzmSlideshow;






